import { render } from "./AttachmentList.vue?vue&type=template&id=8b637a22&scoped=true&ts=true"
import script from "./AttachmentList.vue?vue&type=script&lang=ts"
export * from "./AttachmentList.vue?vue&type=script&lang=ts"

import "./AttachmentList.vue?vue&type=style&index=0&id=8b637a22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b637a22"]])

export default __exports__